/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconWifi0 = createReactComponent("wifi-0", "IconWifi0", [
  ["path", { d: "M12 18l.01 0", key: "svg-0" }]
]);

export { IconWifi0 as default };
//# sourceMappingURL=IconWifi0.js.map
